<template>

    <div class="scroll-carousel w-100" v-inview:on="inviewFunc" :style="containerStyles" ref="scroll-container">
      <div class="scroll-carousel-locked-content" :style="contentStyles" :class="{ 'unlocked': unlocked }">
          <component :is="contentComponent" :progress="progress" :culture-code="cultureCode">
          </component>
      </div>
    </div>

</template>

<style lang="scss">
    .scroll-carousel {
    }

    .scroll-carousel-locked-content {
        display: flex;
        align-items: center;
        justify-content: center;
        // background-color: green;
        height: 100vh;
        background-color: $white;
    }
</style>

<script>
    // TODO: maybe make this more generically named?
    // Figure out how to get the 'scroll progress', pass it to some other component that is a child (using slots somehow..)
    // Make child carousel thing.
    // Figure out how to update the page scroll position for when a user clicks on a link or uses keyboard navigation

    function getCoords(elem) { // crossbrowser version
        var box = elem.getBoundingClientRect();

        var body = document.body;
        var docEl = document.documentElement;

        var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

        var clientTop = docEl.clientTop || body.clientTop || 0;
        var clientLeft = docEl.clientLeft || body.clientLeft || 0;

        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;

        return { top: Math.round(top), left: Math.round(left) };
    }

    export default {

        props: {
            contentComponent: {
                type: String,
                default: "investment-solutions-carousel"
            },
            scrollHeight: {
                type: Number,
                default: 4000,
            },
            unlockAtEnd: {
                type: Boolean,
                default: true
            },
            cultureCode: {
                type: String,
                default: "en-US"
            }
        },
        data() {
            return {

                windowHeight: 0,
                carouselWidth: 0,
                boundingRectY: 0,
                isInView: false,
                unlocked: false,
                forcedProgress: 0.0,
                resetPos: 0,
                isScrolling: false,
                wasScrolling: false,
                scrollInterval: null,
                scrollEndDebounce: null,
                animating: true
            }
        },
        mounted() {

            window.addEventListener('resize', this.resizeHandler)
            window.addEventListener('scroll', this.scrollHandler)
            this.resizeHandler();

            this.applyScroll();

            let thisComp = this;

            let animStep = function () {
                if (thisComp.isScrolling) {
                    if (thisComp.scrollEndDebounce) {
                        clearTimeout(thisComp.scrollEndDebounce);
                        thisComp.scrollEndDebounce = null;
                    }

                    thisComp.applyScroll();
                    thisComp.wasScrolling = true;
                    thisComp.isScrolling = false;
                } else {
                    if (thisComp.wasScrolling) {
                        if (thisComp.scrollEndDebounce) {
                            clearTimeout(thisComp.scrollEndDebounce);
                        }
                        thisComp.scrollEndDebounce = setTimeout(() => {
                            thisComp.scrollEndHandler();
                        }, 350);
                    }
                    thisComp.wasScrolling = false;
                }

                if (thisComp.animating) {
                    window.requestAnimationFrame(animStep);
                }
            };

            window.requestAnimationFrame(animStep);

        },
        destroy() {
            this.animating = false;
            window.removeEventListener('resize', this.resizeHandler)
            window.removeEventListener('scroll', this.scrollHandler)

            //clearInterval(this.scrollInterval)
        },
        methods: {
            inviewFunc($v) {
                $v.enter = (el) => {
                    this.isInView = true;
                }
                $v.exit = (el) => {
                    this.isInView = false;
                }
            },
            getWindowHeight() {
                return (window.innerHeight || document.documentElement.clientHeight);
            },
            resizeHandler() {
                this.windowHeight = this.getWindowHeight();

                let el = this.$refs["scroll-container"];

                var scrollTop = getCoords(this.$refs["scroll-container"]).top;

                this.resetPos = scrollTop;

                if (el) {
                    let bounding = el.getBoundingClientRect();

                    this.carouselWidth = bounding.width;

                    if (!this.unlocked && this.unlockAtEnd && this.progress >= 1.0) {
                        this.isScrolling = true;
                        // DRY
                        // this.unlocked = true;
                        // this.forcedProgress = 1.0;
                        // this.boundingRectY = bounding.y || bounding.top;   
                        // window.scrollTo(0, getCoords(el).top);
                    }

                }

            },
            scrollHandler() {
                this.isScrolling = true;
            },
            applyScroll() {
                //console.log(window.pageYOffset);

                if (this.unlocked) {
                    return;
                }

                let el = this.$refs["scroll-container"];

                if (el) {
                    let bounding = el.getBoundingClientRect();

                    this.boundingRectY = bounding.y || bounding.top;
                }
            },
            scrollEndHandler() {
                let el = this.$refs["scroll-container"];
                var oldRect = el.getBoundingClientRect();
                var prog = -this.boundingRectY / ((this.scrollHeight - this.windowHeight));
                var oldY = window.pageYOffset;
                if (this.unlockAtEnd && prog >= 1.0 && !this.unlocked) {

                    this.forcedProgress = 1.0;
                    this.unlocked = true;
                    this.$forceUpdate();

                    this.$nextTick(() => {
                        var newRect = el.getBoundingClientRect();
                        // console.log("offs " + (newRect.height - oldRect.height));
                        window.scrollTo(0, oldY + (newRect.height - oldRect.height));
                    });
                }

            },
            scrollTo(scrollToProgress) {
                if (this.unlocked) {

                    this.forcedProgress = scrollToProgress;
                    this.$forceUpdate();
                    setTimeout(() => {
                        window.scrollTo({
                            left: 0,
                            top: getCoords(this.$refs["scroll-container"]).top,
                            behavior: 'smooth'
                        });
                    }, 50)
                    return;
                } else {
                    let el = this.$refs["scroll-container"];
                    window.scrollTo(0, el.offsetTop + (scrollToProgress * (this.scrollHeight - this.windowHeight)));
                }
            }
        },

        computed: {
            progress: function () {
                if (this.unlocked) {
                    return this.forcedProgress;
                } else {
                    return (this.boundingRectY < 0.0) ? Math.min(-this.boundingRectY / ((this.scrollHeight - this.windowHeight)), 1.0) : 0
                }

            },
            containerStyles: function () {
                if (this.unlocked) {
                    return {
                        height: "auto",
                    }
                } else {
                    return {
                        height: this.scrollHeight + "px"
                    }
                }
            },
            contentStyles: function () {
                if (this.unlocked) {
                    return {

                    }
                } else {
                    return {
                        width: this.carouselWidth + "px",
                        top: (this.boundingRectY < -(this.scrollHeight - this.windowHeight)) ? (this.scrollHeight - this.windowHeight) + this.boundingRectY + "px" : "0px",
                        //top: "0px",
                        "z-index": 6,
                        position: (this.boundingRectY < 0) ? "fixed" : "relative"
                    };
                }
            }
        }
    }
</script>